// app/components/ArticleSchema.tsx

import { ImageData } from "~/interface/commonImagesize-types";

interface ArticleSchemaProps {
  type: "BlogPosting" | "NewsArticle";
  headline: string;
  description?: string;
  image?: string[];
  datePublished?: string;
  dateModified?: string;
  url?: string;
  author?: {
    name: string;
    url?: string;
  };
  publisher?: {
    name: string;
    logo: string;
    url: string;
  };
  keywords?: string;
  articleSection?: string;
  wordCount?: number;
  inLanguage?: string;
}

export function ArticleSchema({
  type,
  headline,
  description,
  image,
  datePublished,
  dateModified,
  url,
  author,
  publisher,
  keywords,
  articleSection,
  wordCount,
  inLanguage,
}: ArticleSchemaProps) {
  const imageArray = image ? (Array.isArray(image) ? image : [image]) : undefined;

  const schema = {
    "@context": "https://schema.org",
    "@type": type,
    headline,
    ...(description && { description }),
    ...(imageArray && { image: imageArray }),
    ...(datePublished && { datePublished }),
    ...(dateModified && { dateModified: dateModified || datePublished }),
    ...(url && { url }),
    ...(keywords && { keywords }),
    ...(articleSection && { articleSection }),
    ...(wordCount && { wordCount }),
    ...(inLanguage && { inLanguage }),
    ...(author && {
      author: {
        "@type": "Person",
        name: author.name,
        ...(author.url && { url: author.url }),
      },
    }),
    ...(publisher && {
      publisher: {
        "@type": "Organization",
        name: publisher.name,
        logo: {
          "@type": "ImageObject",
          url: publisher.logo,
        },
        ...(publisher.url && { url: publisher.url }),
      },
    }),
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }} />;
}
